export default __webpack_public_path__ + "static/media/ImageCine.c0906127.svg";